/**
 * Credential (PIV issuance) decision values a COR can select at approval.
 *
 * Single source of truth for the COR credential decision: the validation layer builds
 * `CredentialTypeEnum` (@access-cms/validation) from it, and the approvals UI derives
 * its `PivCardSelection` type and re-approval prefill from it. The legacy
 * 'external_nonfederal_piv' value still appears on old records but is not selectable.
 */
export const CREDENTIAL_TYPES = ['piv', 'remote_rla', 'external_federal_piv'] as const;

export type CredentialType = (typeof CREDENTIAL_TYPES)[number];
